<template>
  <el-header height="64px" class="headtop">
    <!-- <i :class="['iconfont','icon-shrink','hide-menu']" @click="hideMenuTag=!hideMenuTag"></i> -->
    <!-- <img src="../assets/img/logo.png" alt="" class='imgs' @click="go('home')"> -->
    <div :class='chooseindex==2||chooseindex==4?"headleft":"headleft1"'>
      <img src="../assets/homelogo.png" alt="" class="logo">
      <p class="title">宇健康医生端</p>
    </div>
    <div class="header-right">
      <el-dropdown>
        <el-badge :is-dot='wd' class="item">
          <img class="messageimg" src="../assets/message.png" alt="" @click='setRead'>
        </el-badge>
        <el-dropdown-menu slot="dropdown" v-if='messageList.length>0'>
          <p class="mestitle">消息</p>
          <el-dropdown-item v-for='item in messageList' :key='item.id'><img src="../../src/assets/xx.png" alt="">
            <p>{{item.content}}</p>
          </el-dropdown-item>
        </el-dropdown-menu>
        <el-dropdown-menu slot="dropdown" v-else>
          <p class="" style='width:100%;text-align:center;margin-bottom:0'>暂无消息</p>

        </el-dropdown-menu>
      </el-dropdown>
      <img class="headPicture" :src="info.headPicture" alt="">
      <a class="iconfont"><span>{{info.username}}</span></a>
      <a class="iconfont icontuichu" @click="toLogout"><span>退出</span></a>
    </div>
    <div class="header-left">
      <p v-for='(item,index) in menu' :key="item.id" @click='clickp(index)' :class="item.checked?'hascolor':''">
        {{item.text}}</p>
    </div>
  </el-header>
</template>
<script>
  import {
    mapActions,
    mapState
  } from 'vuex'
  import {
    headUrl
  } from '@/utils/imageUrl'
  import {
    getuserInfo,
    getRead,
    remindlist,
    setRead
  } from "../api/getData";
  export default {
    name: 'headertop',
    inject: ['reload'],
    data() {
      return {
        userName: localStorage.getItem("userInfo") &&
          JSON.parse(localStorage.getItem("userInfo")).userId,
        hideMenuTag: this.hideMenu,
        menu: [{
          id: 5,
          text: '汇总方案',
          checked: false,
        }, {
          id: 4,
          text: '方案列表',
          checked: false,
        }, {
          id: 3,
          text: '私密问诊',
          checked: false,
        }, {
          id: 2,
          text: '医生小组',
          checked: false,
        }, {
          id: 1,
          text: '会诊',
          checked: true,
        }, ],
        info: {},
        chooseindex: 4,
        messageList: [],
        totalPage: '0',
        wd: false,
      }
    },
    props: {
      hideMenu: Boolean
    },
    created() {
      for (let i = 0; i < this.menu.length; i++) {
        this.menu[i].checked = false;
      }
      if (localStorage.index != '' && localStorage.index != null && localStorage.index != undefined) {
        this.menu[localStorage.index].checked = true;
        this.chooseindex = localStorage.index
      } else {
        this.menu[4].checked = true;
      }
      this.getRead();
      this.remindlist()
      this.getuserInfo();
      let that = this
      setInterval(function () {
        that.getRead();
        that.remindlist()
      }, 300000);

    },
    computed: {
      ...mapState({
        userInfo: state => state.userInfo
      }),
      absUrl() {
        return headUrl(this.userInfo.headImgUrl)
      }
    },
    methods: {
      ...mapActions(["onLogout"]),
      toLogout() {
        this.onLogout();
      },

      async setRead() {
        var res = await setRead();
        if (res.code == "0") {
            this.wd=false;
        } else {

        }
      },
      // 获取用户信息
      async getRead() {
        var res = await getRead();
        if (res.code == "0") {
          this.wd = res.data
        } else {

        }
      },
      // 获取用户信息
      async remindlist() {
        var res = await remindlist({
          page: 1,
          rows: 9999
        });
        if (res.code == "0") {
          this.totalPage = res.data.totalPage;
          this.messageList = res.data.list
        } else {

        }
      },
      // 获取用户信息
      async getuserInfo() {
        var res = await getuserInfo();
        if (res.code == "0") {
          this.info = res.data
        } else {

        }
      },
      clickp(index) {
        for (let i = 0; i < this.menu.length; i++) {
          this.menu[i].checked = false;
        }
        this.menu[index].checked = true;
        localStorage.isshow = false;
        localStorage.index = index;
        this.chooseindex = index
        if (index == 1) {
          this.$router.push("/planList");
        } else if (index == 0) {
          this.$router.push("/dhzplanList");
        } else if (index == 2) {
          // this.refresh('/contact/smwz');
          this.$router.push("/contact/smwz");
          this.reload();
        } else if (index == 3) {
          // this.refresh('/contact/ysxz');
          this.$router.push("/contact/ysxz");
          this.reload();
        } else if (index == 4) {
          // this.refresh('/contact/hz');
          this.$router.push("/contact/hz");
          this.reload();
        }
      },
      refresh(url) {
        this.$router.replace({
          path: '/kong?url=' + url,

        })
      },
      ...mapActions(['getAdminData']),
      async handleCommand(command) {
        if (command == 'singout') {
          const res = await signout()
          if (res.errno == "0") {
            this.$message({
              type: 'success',
              message: '退出成功'
            });
            this.$router.push('/');
          } else {
            this.$message({
              type: 'error',
              message: res.errmsg
            });
          }
        }
      },
      go(url) {

        this.$router.push("/" + url);

      },
    },
    watch: {
      //   userInfo: function (newVlaue) {
      //     if (!newVlaue.name) {
      //       this.$router.push("/");
      //     }
      //   },
      hideMenuTag: function (newVlaue) {
        console.log(newVlaue);
        this.$emit('update:hideMenu', newVlaue);
      }
    }
  }

</script>
<style lang="less">
  @import '../style/mixin';

  .el-dropdown-menu {
    width: 400px;

    .el-dropdown-menu__item {
      width: 100%;
      float: left;

      img {
        width: 50px;
        height: 50px;
        float: left;
        margin: 12px 0px;
        margin-right: 20px;
      }

      p {
        width: 280px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        line-height: 20px;
        margin: 20px 0;
        float: left;
      }
    }

    .mestitle {
      width: 100%;
      // height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 800;
      color: rgba(68, 68, 68, 1);
      line-height: 28px;
      margin: 0 20px;
      float: left;
      padding-bottom: 10px;
      border-bottom: 1px solid #E5E5E5
    }
  }

  .headtop {
    background-color: #fff;

    .item {
      margin-right: 20px
    }

    .headPicture {
      border-radius: 100%;
      height: 40px;
      width: 40px
    }

    .headleft {
      float: left;
      width: 20%;
      // min-width: 235px;
      background-color: #002140;


      .imgs {
        height: 28px;
        float: left;
        margin-top: 16px;
        margin-right: 10px;
      }

      .title {
        text-align: left;
        line-height: 64px;
        font-size: 20px;
        float: left;
        font-weight: 600;
        color: rgba(49, 65, 89, 1);
        padding: 0;
        color: #fff;
        margin-bottom: 0
      }
    }

    .headleft1 {
      float: left;
      width: 20%;
      // min-width: 235px;
      background-color: #fff;

      .imgs {
        height: 28px;
        float: left;
        margin-top: 16px;
        margin-right: 10px;
      }

      .title {
        text-align: left;
        line-height: 64px;
        font-size: 22px;
        float: left;
        font-weight: 600;
        color: rgba(49, 65, 89, 1);
        padding: 0;
        color: #000;
        margin-bottom: 0
      }
    }

    .logo {
      width: 40px;
      height: 40px;
      float: left;
      margin: 10px;
      margin-left: 30px
    }

    .hascolor {
      color: #3F86FF !important;
      font-weight: 800;
    }

    .avator {
      .wh(32px, 32px);
      border-radius: 50%;
      margin-left: 14px;
    }

    .hide-menu {
      font-size: 22px;
      line-height: 56px;
    }

    .el-dropdown-menu__item {
      text-align: center;
    }

    .el-header {
      position: relative;
      padding: 0;
      color: #000;
      font-family: 'PingFangSC-Regular';
      background: #fff;




    }


    .el-header .el-dropdown-username {
      line-height: 32px;
      float: right;
      font-size: 14px;
      margin-left: 8px;
    }

    .el-dropdown-username {
      font-weight: 600;
    }

    .header-left {
      float: right;
      margin-right: 50px;
      // width: 70%;
      height: 64px;



      p {
        float: right;
        width: auto;
        line-height: 64px;
        padding: 0 30px;
        font-size: 18px;
        cursor: pointer;
        -moz-user-select: none;
        -khtml-user-select: none;
        user-select: none;
        color: #444;

      }
    }

    .header-right {
      float: right;
      margin-right: 30px;
      width: auto;

    }

    .header-right a.iconfont {
      font-size: 22px;
      margin-left: 10px;
      line-height: 60px;
    }

    .header-right a.iconfont span {
      font-size: 12px;
      margin: 0 10px;
      line-height: 64px;
      vertical-align: middle;
      color: #000;
    }

    .icontuichu span {
      color: #3F86FF !important;
    }

    .header-right a.iconfont:hover {
      color: #7781a2;
      cursor: pointer;
    }

    .el-popper[x-placement^=bottom] {
      margin-top: 20px;
    }

    .messageimg {
      height: 25px;
    }

    .el-dropdown-menu {
      width: 450px;
    }

    .el-dropdown-menu__item {
      text-align: left;
      line-height: 25px;
      padding: 2%;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/headerTop.vue